

    import React,{Component} from 'react';
	
	 //import {BrowserRouter,Route,Link} from 'react-router-dom';
	import axios from "axios";
	
	 
	class UpdatesComponent extends Component{
	
		constructor(props)
		{
			super(props)
			
			this.state = {
				typeName: null,
				type: null,
				id: null,
				loading:false
			}

			
			this.handleTypeName = this.handleTypeName.bind(this); 
			this.handleType = this.handleType.bind(this); 
			this.handleTypeSubmit = this.handleTypeSubmit.bind(this); 

		}
	

         
       async componentDidMount()
	   {
		   //get details from url
		   this.setState({id: this.props.match.params.id});
		   this.setState({type: this.props.match.params.type});
		   this.setState({typeName: this.props.match.params.username});
		   
	   
	   }
	   
       async componentDidUpdate()
        {
           
		   if((this.state.id === null) || (this.state.id === "") || (this.state.type === null) || (this.state.type === ""))
		   {
				alert("Bad request!");
				this.props.history.push("/gitsearch/");
		   }

		   try
			 {
				   //get user access token
				   let token = localStorage.getItem("token");
				   
				   if((token === "noToken") || (token === null))
				   {
				   alert("Ilegal page view");
				   this.props.history.push("/gitsearch/");
				   }

				   let userDataResponse = await axios({
				   method: "get",
				   url: "http://mofehintolumumuni.com/gitserver/api/users/profile",
				   headers: {"Authorization": "Bearer "+token}
				   });

				   let requestStatus = userDataResponse.data.status;
				   //let payload = userDataResponse.data.data

				   if(requestStatus !== "success")
				   {

					this.props.history.push("/gitsearch/");
			   
				   }
				 

			   }
			   catch(error)
			   {
				this.props.history.push("/gitsearch/");
			   }
        }

       

		
		handleTypeName(e)
		{
			
			this.setState({typeName: e.target.value});
		}

		handleType(e)
		{
			this.setState({type:e.target.value});
		}

		async handleTypeSubmit(e)
		{
			e.preventDefault();


			this.setState({loading:true});

			//get user access token
			let token = localStorage.getItem("token");

			var endPoint = null;
			var dataValue = null;
			//get type and select endpoint to query
			if((this.state.type !== null) && (this.state.type !== ""))
			{
				if(this.state.type === "organization")
				{
					endPoint = "/api/users/preference/github/repoSearch/edit";
					dataValue =  {
						orgname :this.state.typeName,
						id: this.state.id
						};
					
				}
				if(this.state.type === "user")
				{
					endPoint = "/api/users/preference/github/usersearch/edit";
					dataValue = {
						username :this.state.typeName,
						id: this.state.id
						};
					
				}
				//alert(this.state.typeName);
				
				if((this.state.typeName !== null) && (this.state.typeName !== ""))
				{	
					try{
							//make axios call
					let response = await axios({
						method: "put",
						url: `http://mofehintolumumuni.com/gitserver${endPoint}`,
						"data":dataValue,
						headers: {"Authorization": "Bearer "+token},
					"Content-Type": "application/x-www-form-urlencoded"
					});

					let status = response.data.status;
					let message = response.data.data;

						if(status === "success")
						{
							this.setState({loading:false});
							alert("Data saved successfully!");
						}
						else
						{
							this.setState({loading:false});
							alert(`Data not saved successfully! ${message}`);
						}
					}
					catch(error)
					{	this.setState({loading:false});
						alert("Data not saved successfully! "+error);
					}
				

				}
				else
				{
					this.setState({loading:false});
					alert("Data not saved successfully!");
				}
			}
			else
			{
				this.setState({loading:false});
				alert("Fill the form properly before submitting form");
			}

			
		}




	render()
	{
	return(
	
		<React.Fragment>
		<section>
		<div id="page-wrapper" class="sign-in-wrapper">
				<div class="graphs">
					<div class="sign-in-form">
						<div class="sign-in-form-top">
							<h1 >UPDATE DETAILS <i class="fa fa-sign-in custom"></i></h1>
							{(this.state.loading) ? <h3>Loading data from Server <i className="fa fa-cogs" ></i> </h3> : null}
						
						{(this.state.typeName !== null) ?<p>TYPE: {this.state.type}</p> : null}
						{(this.state.typeName !== null) ?<p>CURRENT NAME:: {this.state.typeName}</p> : null}

						</div>
						<div class="signin">
						
							<form onSubmit={this.handleTypeSubmit}>
							<div class="log-input">
								<div class="log-input-left">
								  <input type="text" placeholder="Enter name..."  onChange={this.handleTypeName} />
								</div>
								
								<div class="clearfix"> </div>
							</div>
							
							<input id="logi" type="submit" name="send" value="UPDATE" />
						</form>	 
						<br></br>
                        <br></br>
						<br></br>
	
						</div>
					
					</div>
				</div>
			</div>
			</section>
</React.Fragment>

	);
	}


    }
    



    export default UpdatesComponent;


